export const pagesEN = {
  home: {
    help: 'Learn More',
    memes: 'Do you like <span class="text-info">MEMEs</span>?',
    nfts: 'Do you like <span class="text-info">NFTs</span>?',
    headline: '<em class="text-info">NFT your MEME</em> today!',
    create: 'NFT your MEME, get it voted into the Top 10 and earn $NUTS!',
    vote: 'Vote for your favourites memes to decide which ones are the best.',
    auction: 'Biweekly, the <em>Top 10</em> most voted memes win <strong><em>$NUTS</em></strong>!',
    docs: 'For more info check out our <a href="https://docs.elrondbet.net/memes/xmemes" target="_blank" class="ms-1 btn btn-sm btn-outline-light">docs <i class="bi bi-box-arrow-up-right"></i></a>',
  },
  notFound: {
    title: '404: Page not found...',
    subtitle: 'There has been an error while trying to display this page',
    link: 'Back to Homepage',
  },
};
